/** LY mark (from lysoftwares.com) + product wordmark. */
export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <svg
      className="brand-mark"
      width={size}
      height={size}
      viewBox="2.1 0.6 37.8 37.8"
      fill="none"
      aria-hidden="true"
    >
      <path d="M9.2 34.8 A 18 18 0 0 1 33.4 9.0 A 14.2 14.2 0 0 0 9.2 34.8Z" fill="#7C5CFF" />
      <g transform="translate(27,24) scale(.8) translate(-26,-22)">
        <g stroke="#7C5CFF" strokeWidth="4.8" strokeLinecap="round" strokeLinejoin="round" fill="none">
          <path d="M12.6 13 V28.2 Q12.6 32 16.4 32 H22" />
          <path d="M32.4 32 V17.8" />
        </g>
        <path d="M32.4 21.8 C27.6 21.8 24.6 18.6 24.6 14.4 C29.4 14.4 32.4 17.6 32.4 21.8Z" fill="#B6E64A" />
        <path
          d="M32.4 19.4 C37.2 19.4 40.2 16.2 40.2 12 C35.4 12 32.4 15.2 32.4 19.4Z"
          fill="#B6E64A"
          opacity=".6"
        />
      </g>
    </svg>
  );
}

/** Product lockup: LY mark + "LY360". The name is never translated or split. */
export function Brand({ size = 36, label }: { size?: number; label?: string }) {
  return (
    <div className="brand">
      <BrandMark size={size} />
      <span className="brand-name">LY360</span>
      {label && <span className="brand-tag">{label}</span>}
    </div>
  );
}
